// @ts-check
if (!customElements.get("ff-collection-banner-description")) {
  class FfCollectionBannerDescription extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.ffHtml) {
        const descriptionDOM = new DOMParser().parseFromString(
          this.dataset.ffHtml,
          "text/html"
        );
        const firstDiv = descriptionDOM.querySelector("div");

        if (firstDiv) {
          this.appendChild(firstDiv);
        } else {
          const firstP = descriptionDOM.querySelector("p");
          if (firstP) {
            this.appendChild(firstP);
          } else {
            console.error("Not <div> neither <p> found.");
          }
        }
      } else {
        console.error("Missing html data property");
      }
    }
  }

  customElements.define(
    "ff-collection-banner-description",
    FfCollectionBannerDescription
  );
}
